type TransformSingleBidAskDataType = {
  BO: number;
  BP: number;
  BQ: number;
  row: number;
  SO: number;
  SP: number;
  SQ: number;
};

type TransformBidAskChangeDataType = {
  isin: string;
  rows: TransformSingleBidAskDataType[];
};
function transformSingleBidAsk(item: TransformSingleBidAskDataType) {
  const {
    BO: askNumber,
    BP: askPrice,
    BQ: askQuantity,
    row: rowPlace,
    SO: bidNumber,
    SP: bidPrice,
    SQ: bidQuantity,
  } = item;

  return {
    rowPlace,
    bidPrice,
    bidNumber,
    bidQuantity,
    askPrice,
    askNumber,
    askQuantity,
  };
}

function transformBidAskChange(data: TransformBidAskChangeDataType) {
  const { isin: isin, rows: bidAsk } = data;

  return {
    isin,
    bidAsk: bidAsk.map(transformSingleBidAsk),
  };
}

export { transformBidAskChange };
